import { createContext, useContext, useState, useEffect } from 'react';
import type { ReactNode } from 'react';
// @ts-ignore
import { getNewCategories } from '../services/newCategoryService';
// @ts-ignore
import { getNews } from '../services/newsService';
// @ts-ignore
import { getServicesForCustomer } from '../services/serviceService';
// @ts-ignore
import { getFooterForCustomer } from '../services/settingService';

export interface LayoutData {
  newsCategories: any[];
  featuredNews: any[];
  services: any[];
  solutions: any[];
  academy: any;
  footerData: any;
  loading: boolean;
}

const initialState: LayoutData = {
  newsCategories: [],
  featuredNews: [],
  services: [],
  solutions: [],
  academy: null,
  footerData: null,
  loading: true,
};

const LayoutDataContext = createContext<LayoutData>(initialState);

export const useLayoutData = () => useContext(LayoutDataContext);

interface LayoutDataProviderProps {
  children: ReactNode;
}

export const LayoutDataProvider = ({ children }: LayoutDataProviderProps) => {
  const [data, setData] = useState<LayoutData>(initialState);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [categoriesRes, newsRes, servicesRes, footerRes] = await Promise.all([
          getNewCategories({ page: 1, limit: 10, isActive: true }),
          getNews({ page: 1, limit: 3, isActive: true, sort: '-createdAt' }),
          getServicesForCustomer(),
          getFooterForCustomer(),
        ]);

        let newsData: any[] = [];
        if (newsRes?.data?.news) newsData = newsRes.data.news;
        else if (newsRes?.data && Array.isArray(newsRes.data)) newsData = newsRes.data;
        else if (Array.isArray(newsRes)) newsData = newsRes;

        let filteredSolutions: any[] = [];
        let filteredServices: any[] = [];
        let filteredAcademy: any = null;
        if (servicesRes?.data?.services) {
          const all = servicesRes.data.services;
          filteredSolutions = all.filter((s: any) => s.type === 'solution');
          filteredServices = all.filter((s: any) => s.type === 'service');
          filteredAcademy = all.find((s: any) => s.type === 'academy' && s.isFeatured) || null;
        }

        setData({
          newsCategories: categoriesRes?.data?.categories || [],
          featuredNews: newsData,
          services: filteredServices,
          solutions: filteredSolutions,
          academy: filteredAcademy,
          footerData: footerRes?.success ? footerRes.data : null,
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching layout data:', error);
        setData((prev) => ({ ...prev, loading: false }));
      }
    };

    fetchAll();
  }, []);

  return (
    <LayoutDataContext.Provider value={data}>
      {children}
    </LayoutDataContext.Provider>
  );
};
